<template>
  <ModalDefault
    :id="modalId"
    :title="resultadoActual.titulo"
    :size="resultadoActual.sizeModal"
  >
    <template #modal-body>
      <div class="overflow-hidden">
        <ListaSqlGrafica
          v-if="tipoGrafica"
          :resultado="resultadoGrafica"
          :tipo-grafica="tipoGrafica"
          modal
        />
        <ListaSqlTabla
          v-else
          :resultado="resultado"
          :identification="`${modalId}-tabla`"
          :max-height="true"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue'
import type {
  IListaSqlResultado,
  IListaSqlResultadoGrafica,
  TipoGraficaListaSql
} from '@/modules/Configuracion/interfaces'
import { normalizarResultadoListaSql } from '@/modules/Configuracion/utils/listaSql'
import { useModal } from '@/modules/Core/composables/useModal'
import ListaSqlTabla from '@/modules/Core/components/ListaSql/ListaSqlTabla.vue'
import ListaSqlGrafica from '@/modules/Core/components/ListaSql/ListaSqlGrafica.vue'

const props = defineProps<{
  modalId: string
  tipoGrafica?: TipoGraficaListaSql
}>()

const { openModalById } = useModal()
const resultado = ref<IListaSqlResultado>(normalizarResultadoListaSql([], 'Consulta SQL'))
const resultadoGrafica = ref<IListaSqlResultadoGrafica>({
  titulo: 'Consulta SQL',
  sizeModal: 'md',
  puntos: []
})
const resultadoActual = computed(() => {
  return props.tipoGrafica ? resultadoGrafica.value : resultado.value
})

const open = async (nuevoResultado: IListaSqlResultado | IListaSqlResultadoGrafica) => {
  if ('puntos' in nuevoResultado) resultadoGrafica.value = nuevoResultado
  else resultado.value = nuevoResultado
  await nextTick()
  openModalById(props.modalId)
}

defineExpose({ open })
</script>
